import parser from './epubParser';
import parseLink from './parseLink';
import parseHTML from './parseHTML';
import { parseNestedObject } from './utils';
export { parseLink, parseHTML, parseNestedObject };
export default parser;



//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 4
// module chunks = 0